export default {
  title: 'Unternehmensübersicht',
  description: 'Willkommen zurück, {{name}}! Hier ist, was mit Ihrem Marketing passiert.',
};
